import React from 'react';

export default function SatisfactionGuaranteeModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="guarantee-modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-lg w-full p-6 sm:p-8 shadow-2xl border border-[#D9DDE2] relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Luk dialog"
          className="absolute top-4 right-4 text-[#6c7480] hover:text-[#5A232E] p-2 rounded-full hover:bg-[#D9DDE2] transition-colors"
        >
          <i className="fa-solid fa-xmark text-lg" aria-hidden="true" />
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-[#5A232E]/10 text-[#5A232E] flex items-center justify-center">
            <i className="fa-solid fa-shield-check text-xl" aria-hidden="true" />
          </div>
          <h2 id="guarantee-modal-title" className="font-display text-2xl text-[#5A232E]">
            100% Tilfredshedsgaranti
          </h2>
        </div>

        <p className="text-sm font-medium text-[#5A232E] mb-3">
          Tydelige og konkrete vilkår for din tryghed
        </p>

        <div className="text-sm text-[#11161d] space-y-3 leading-relaxed">
          <p>
            Det er afgørende for et vellykket terapeutisk forløb, at du føler dig 100% tryg ved mig som terapeut og mærker den rette menneskelige kemi.
          </p>
          <div className="bg-[#ECEEF1] p-4 rounded-xl border border-[#D9DDE2]/80 space-y-2">
            <div className="font-medium text-[#5A232E] flex items-center gap-2">
              <i className="fa-solid fa-check text-[#5A232E]" aria-hidden="true" />
              Hvad garantien omfatter:
            </div>
            <p className="text-xs text-[#6c7480]">
              Hvis du under din første betalte session (inden for de første 30 minutter) fornemmer, at kemien ikke er der, eller at forløbet ikke matcher dine forventninger, afslutter vi sessionen uden beregning. Du skal blot give besked undervejs.
            </p>
          </div>

          <div className="bg-amber-50/70 p-4 rounded-xl border border-amber-200/80 space-y-2">
            <div className="font-medium text-amber-900 flex items-center gap-2">
              <i className="fa-solid fa-circle-info text-amber-700" aria-hidden="true" />
              Vigtig præcisering:
            </div>
            <p className="text-xs text-amber-800">
              Garantien vedrører din oplevelse af kemi, tryghed og sessionens rammer. Den udgør ikke — og må lovmæssigt ikke udgøre — en garanti for et specifikt klinisk, medicinsk eller psykisk resultat eller helbredelse, da enhver terapeutisk forandringsproces er et individuelt samarbejde.
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2.5 bg-[#5A232E] text-white rounded-lg text-sm font-medium hover:bg-[#431722] transition-colors"
          >
            Forstået
          </button>
        </div>
      </div>
    </div>
  );
}
